export const sequence_detail_report_en = {
  campaign: "Campaign Metrics",
  event: "Event Metrics",
  campaign_description:
    "Measure actions tied to a campaign’s target and its performance during the period. Ideal for assessing targeted impact and results.",
  event_description:
    "Capture interactions happening within a period, independent of campaign targets. Useful for monitoring real-time engagement and activity trends.",

  metrics: "metrics",
  interactions: "interactions",
  timestamp: "timestamp",
  find_by: "Find by",
  metric_type: "Metric",
  date_range: "Timeline",
  filter: "Filter",

  sequence_report_last_node_name: "End point",
  sequence_report_last_node_title: "Step complete",
  sequence_report_last_node_desc: "No Further Action",

  sequence_report_analytics_chart_title: "Engagement Trends",

  interactions_count: "0 interactions | 1 interaction | {count} interactions",

  sequence_report_empty_title: "No analytics yet",
  sequence_report_empty_desc:
    "Analytics will appear here once you've added and run steps in your sequence.",
  sequence_report_empty_go_steps: "Go to steps",

  sequence_report_analytics_empty_title: "No analytics data yet",
  sequence_report_analytics_empty_desc:
    "Analytics will appear here once your campaign starts running and engagement data is collected",
};

export const sequence_detail_report_zhCN = {
  campaign: "活动指标",
  event: "事件指标",
  campaign_description:
    "衡量与活动目标及其期间表现相关的操作。适合评估目标影响和结果。",
  event_description:
    "捕获特定时间段内的交互，独立于活动目标。用于监控实时参与度和活动趋势。",

  metrics: "指标",
  interactions: "交互",
  timestamp: "时间戳",
  find_by: "查找方式",
  metric_type: "指标类型",
  date_range: "时间范围",
  filter: "筛选",

  sequence_report_last_node_name: "结束节点",
  sequence_report_last_node_title: "步骤完成",
  sequence_report_last_node_desc: "无需进一步操作",

  sequence_report_analytics_chart_title: "参与趋势",
  interactions_count: "0 次互动 | 1 次互动 | {count} 次互动",

  sequence_report_empty_title: "暂无分析数据",
  sequence_report_empty_desc:
    "当您在序列中添加并运行步骤后，分析数据将在此显示。",
  sequence_report_empty_go_steps: "前往步骤设置",

  sequence_report_analytics_empty_title: "暂无分析数据",
  sequence_report_analytics_empty_desc:
    "当您的活动开始运行并收集到参与数据后，分析数据将在此显示",
};

export const sequence_detail_report_zhTW = {
  campaign: "活動指標",
  event: "事件指標",
  campaign_description:
    "衡量與活動目標及其期間表現相關的操作。適合評估目標影響和結果。",
  event_description:
    "捕獲特定時間段內的互動，獨立於活動目標。用於監控即時參與度和活動趨勢。",

  metrics: "指標",
  interactions: "互動",
  timestamp: "時間戳記",
  find_by: "查找方式",
  metric_type: "指標類型",
  date_range: "時間範圍",
  filter: "篩選",

  sequence_report_last_node_name: "結束節點",
  sequence_report_last_node_title: "步驟完成",
  sequence_report_last_node_desc: "無需進一步操作",

  sequence_report_analytics_chart_title: "互動趨勢",
  interactions_count: "0 次互動 | 1 次互動 | {count} 次互動",

  sequence_report_empty_title: "暫無分析資料",
  sequence_report_empty_desc:
    "當您在序列中添加並執行步驟後，分析資料將在此顯示。",
  sequence_report_empty_go_steps: "前往步驟設定",

  sequence_report_analytics_empty_title: "暫無分析資料",
  sequence_report_analytics_empty_desc:
    "當您的活動開始執行並收集到互動資料後，分析資料將在此顯示",
};

export const sequence_detail_report_ja = {
  campaign: "キャンペーン指標",
  event: "イベント指標",
  campaign_description:
    "キャンペーンのターゲットと期間中のパフォーマンスに関連するアクションを測定します。ターゲットへの影響と結果の評価に最適です。",
  event_description:
    "キャンペーンターゲットとは独立して、特定期間内のインタラクションを捕捉します。リアルタイムのエンゲージメントと活動トレンドの監視に有用です。",

  metrics: "指標",
  interactions: "インタラクション",
  timestamp: "タイムスタンプ",
  find_by: "検索方法",
  metric_type: "指標タイプ",
  date_range: "期間",
  filter: "フィルター",

  sequence_report_last_node_name: "終点",
  sequence_report_last_node_title: "ステップ完了",
  sequence_report_last_node_desc: "これ以上の操作は不要です",

  sequence_report_analytics_chart_title: "エンゲージメント傾向",
  interactions_count:
    "0 件のインタラクション | 1 件のインタラクション | {count} 件のインタラクション",

  sequence_report_empty_title: "分析データがありません",
  sequence_report_empty_desc:
    "シーケンスにステップを追加して実行すると、ここに分析データが表示されます。",
  sequence_report_empty_go_steps: "ステップ設定へ移動",

  sequence_report_analytics_empty_title: "分析データがまだありません",
  sequence_report_analytics_empty_desc:
    "キャンペーンの実行開始後、エンゲージメントデータが収集されると、ここに分析データが表示されます",
};

export const sequence_detail_report_ko = {
  campaign: "캠페인 지표",
  event: "이벤트 지표",
  campaign_description:
    "캠페인 대상 및 기간 중 성과와 관련된 작업을 측정합니다. 대상 영향 및 결과 평가에 이상적입니다.",
  event_description:
    "캠페인 대상과 독립적으로 특정 기간 내 발생한 상호작용을 포착합니다. 실시간 참여도 및 활동 추세 모니터링에 유용합니다.",

  metrics: "지표",
  interactions: "상호작용",
  timestamp: "타임스탬프",
  find_by: "검색 기준",
  metric_type: "지표 유형",
  date_range: "기간",
  filter: "필터",

  sequence_report_last_node_name: "종료 지점",
  sequence_report_last_node_title: "단계 완료",
  sequence_report_last_node_desc: "추가 작업 없음",

  sequence_report_analytics_chart_title: "참여 추이",
  interactions_count: "0건의 상호작용 | 1건의 상호작용 | {count}건의 상호작용",

  sequence_report_empty_title: "분석 데이터 없음",
  sequence_report_empty_desc:
    "시퀀스에 단계를 추가하고 실행하면 분석 데이터가 여기에 표시됩니다.",
  sequence_report_empty_go_steps: "단계 설정으로 이동",

  sequence_report_analytics_empty_title: "아직 분석 데이터 없음",
  sequence_report_analytics_empty_desc:
    "캠페인이 실행되고 참여 데이터가 수집되면 여기에 분석 데이터가 표시됩니다",
};

export const sequence_detail_report_hi = {
  campaign: "अभियान मेट्रिक्स",
  event: "इवेंट मेट्रिक्स",
  campaign_description:
    "एक अभियान के लक्ष्य और उसकी अवधि के दौरान प्रदर्शन से जुड़े कार्यों को मापें। लक्षित प्रभाव और परिणामों का आकलन करने के लिए आदर्श।",
  event_description:
    "अभियान लक्ष्यों से स्वतंत्र, एक निर्दिष्ट अवधि में होने वाली इंटरैक्शन को कैप्चर करें। रीयल-टाइम एंगेजमेंट और गतिविधि रुझानों की निगरानी के लिए उपयोगी।",

  metrics: "मेट्रिक्स",
  interactions: "इंटरैक्शन",
  timestamp: "टाइमस्टैम्प",
  find_by: "खोजने का तरीका",
  metric_type: "मेट्रिक प्रकार",
  date_range: "समय सीमा",
  filter: "फ़िल्टर",

  sequence_report_last_node_name: "समापन बिंदु",
  sequence_report_last_node_title: "चरण पूर्ण",
  sequence_report_last_node_desc: "कोई और कार्रवाई नहीं",

  sequence_report_analytics_chart_title: "सहभागिता रुझान",
  interactions_count: "0 इंटरैक्शन | 1 इंटरैक्शन | {count} इंटरैक्शन",

  sequence_report_empty_title: "अभी कोई एनालिटिक्स नहीं",
  sequence_report_empty_desc:
    "जब आप अपने अनुक्रम में चरण जोड़कर चलाएंगे, तो एनालिटिक्स यहां दिखाई देंगे।",
  sequence_report_empty_go_steps: "चरण सेटिंग पर जाएं",

  sequence_report_analytics_empty_title: "अभी कोई एनालिटिक्स डेटा नहीं",
  sequence_report_analytics_empty_desc:
    "जब आपका अभियान चलना शुरू होगा और एंगेजमेंट डेटा एकत्र किया जाएगा, तो एनालिटिक्स यहां दिखाई देंगे",
};
